module["exports"] = [
  "###-####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ja/address/postcode.js
 ** module id = 787
 ** module chunks = 0
 **/